var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 6.05163C13.5901 6.05163 14.4737 5.1633 14.4737 4.0675C14.4737 2.9717 13.5901 2.08337 12.5001 2.08337C11.41 2.08337 10.5264 2.9717 10.5264 4.0675C10.5264 5.1633 11.41 6.05163 12.5001 6.05163Z",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09868 20.9326C6.18872 20.9326 7.07237 20.0443 7.07237 18.9485C7.07237 17.8527 6.18872 16.9644 5.09868 16.9644C4.00865 16.9644 3.125 17.8527 3.125 18.9485C3.125 20.0443 4.00865 20.9326 5.09868 20.9326Z",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9014 20.9326C20.9915 20.9326 21.8751 20.0443 21.8751 18.9485C21.8751 17.8527 20.9915 16.9644 19.9014 16.9644C18.8114 16.9644 17.9277 17.8527 17.9277 18.9485C17.9277 20.0443 18.8114 20.9326 19.9014 20.9326Z",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2617 5.37207C20.0229 7.01199 21.8749 10.0347 21.8749 13.4922C21.8749 13.7926 21.8609 14.0898 21.8336 14.383V14.383",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1527 22.1744C15.0301 22.6524 13.7956 22.9167 12.4997 22.9167C11.2038 22.9167 9.96932 22.6524 8.84668 22.1744",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16633 14.383C3.13898 14.0898 3.125 13.7926 3.125 13.4922C3.125 10.0347 4.97703 7.01199 7.7382 5.37207",
    stroke: "#6C6D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.406172cee563dcac10213495c500666f.svg";
export { ForwardRef as ReactComponent };